import React from 'react'
import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';

import IND1 from '../../GeoJson/IND1.json'
import IND2 from '../../GeoJson/IND2.json'
import IND3 from '../../GeoJson/IND3.json'

export default function GeoDistStates(props) {


    const newState = ['Assam', 'Sikkim', 'Tripura', 'Arunachal Pradesh', "Meghalaya", "Manipur", "Mizoram", "Nagaland"]

    const filteredFeatures = IND1.features.filter(feature => {
        // marketcountdistrictcenter.map(op=> {
        //     return feature.properties.name === "West Sikkim"
        // })
        ////////console.log("features",feature.properties.name )

        //return feature.properties.name.match(newdists)
        //return newdists.map((a) => a === feature.properties.name)

        return newState.includes(feature.properties.name)
        //return newState.includes(feature.properties.NAME_1)

    });

    const filteredGeoJson = {
        type: "FeatureCollection",
        features: filteredFeatures
    };

    echarts.registerMap('NE', filteredGeoJson);


    let maxValue = 1;

    // for (const item of props.dataechart){
    //     minValue = Math.min(minValue, item.value);
    //     maxValue = Math.max(maxValue, item.value);
    // }

    props.dataechart.forEach(item => {
        // Assuming the count is stored in a property called 'count'
        const count = item.value;
        if (count > maxValue) {
            maxValue = count;
        }
    });

    if (maxValue === 0) {
        maxValue = 1; // Set max to 1 to create a range
    }


    const geooption = {

        title: {
            text: props.text,
            // subtext: 'Registration',
            left: 'left',
            textStyle: {
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'italic' // Add this line to make the text italic
            }
        },
        tooltip: {
            trigger: 'item',
            showDelay: 0,
            transitionDuration: 0.2
        },

        visualMap: {

            show: true,
            left: 'right',
            min: 0,
            max: maxValue,
            inRange: {
                color: ['#ffffff',
                    '#f9bdbb',
                    '#f69988',
                    '#f36c60',
                    '#e84d49',
                    '#d73027',
                    '#990000'
                ]
            },
            text: ['High Strains', 'Low Strains'],
            calculable: true,
        },
        toolbox: {
            show: false,
            //orient: 'vertical',
            left: 'left',
            top: 'top',
            feature: {
                dataView: { readOnly: false },
                restore: {},
                saveAsImage: {}
            }
        },
        series: [
            {
                name: 'No of Strains',
                type: 'map',
                roam: true,
                map: 'NE',
                label: {

                    formatter: function (params) {

                        // if (newdists.includes(params.name)) {
                        //     return params.name;
                        // } else {
                        //     return "";
                        // }


                    },
                    position: 'right', // Set the initial position of labels
                    distance: 5,       // Set the distance from the geo feature
                    verticalAlign: 'middle', // Vertical alignment of labels
                    align: 'left',           // Horizontal alignment of labels
                    fontSize: 15,            // Font size of labels
                    color: '#000',           // Font color of labels
                    emphasis: {
                        // You can also customize the label settings in the highlighted state
                        show: true,
                        color: '#000',
                        fontSize: 12,
                        // Other emphasis label settings...
                    },
                    labelLayout: {
                        // Use 'hideOverlap' to prevent label overlap
                        hideOverlap: true
                    },
                    rich: {
                        // Define the styles for 'a' and 'b'
                        a: {
                            color: 'black', // Label text color
                            fontSize: 12,    // Label text font size
                        },
                        b: {
                            color: 'red',   // Point color
                            fontSize: 16,   // Point font size
                            lineHeight: 14, // Adjust to align point with label
                        },
                    },
                },
                data: props.dataechart,
                itemStyle: {
                    normal: {
                        borderColor: 'black',
                        borderWidth: 1 // Adjust as needed
                    }
                },



            }
        ]
    };
    return (
        <ReactECharts option={geooption} />
    )
}
